import axios from 'axios';
import Swal from 'sweetalert2';
import store from '@/store';
import EventBus from '../event-bus';
import router from '@/router/index';
import { 
  SESSION_TIMEOUT_MESSAGE, 
  START_LOGIN_MESSAGE,
  OK,
  ERROR,
  TIMEOUT,
  NOTLOGGEDIN
} from './ajaxActionResponse';
import { post } from '@/store/modules/fsm/index';
import { LogoutRequest } from '@/store/modules/fsm/messages';
import { RESET_TIMER } from '@/constants/event';

let callLevel = 0;
let timedOut = false;
export const SESSION_TIMEOUT_ERROR = 'Session timed out';
export const inRequest = () => callLevel > 0;

export function isSessionTimeoutError(err) {
  if (!err) return false;
  const msg = typeof err === 'string' ? err : err.message;
  return msg === SESSION_TIMEOUT_ERROR;
}

function isSessionTimeoutPayload(data) {
  if (!data) return false;
  return data.message === SESSION_TIMEOUT_MESSAGE || data.status === TIMEOUT;
}

/** Recover JSON when PHP echoed body before Yii error HTML (legacy denyCallback). */
function normalizeResponseData(raw) {
  if (raw && typeof raw === 'object') return raw;
  if (typeof raw !== 'string') return raw;
  const jsonText = raw.includes('<') ? raw.slice(0, raw.indexOf('<')).trim() : raw.trim();
  try {
    return JSON.parse(jsonText);
  } catch (_) {
    return raw;
  }
}

/**
 * Show timeout UI once, trigger logout, and redirect to login.
 */
export async function handleSessionTimeout() {
  if (timedOut) {
    return Promise.reject(new Error(SESSION_TIMEOUT_ERROR));
  }
  const isLoggingOut = store.getters['login/isLoggingOut'];
  const isLoggedIn = store.getters['login/isLoggedIn'];
  if (isLoggingOut || !isLoggedIn) {
    return Promise.reject(new Error(SESSION_TIMEOUT_ERROR));
  }

  timedOut = true;
  store.commit('login/setIsLoggingOut', true);

  await Swal.fire({
    icon: 'warning',
    title: 'Session timed out',
    text: 'You have been logged out due to lack of activity. Please log in again.',
    confirmButtonText: 'OK',
    allowOutsideClick: false,
  });

  await store.dispatch('login/resetSession');
  store.commit('login/setIsLoggingOut', false);
  await router.replace({ path: '/login' });

  return Promise.reject(new Error(SESSION_TIMEOUT_ERROR));
}

/**
 * This function serves as gateway - 
 * all request and response will go through here
 * 
 * @param {Object} config 
 */
export async function request(config) {
  // Allow login requests even if timedOut is true.
  const isAuthRecoveryUrl =
    config.url &&
    (config.url.includes('/session/login') || config.url.includes('/session/logout'));
  if (timedOut && !isAuthRecoveryUrl) {
    return Promise.reject(new Error(SESSION_TIMEOUT_ERROR));
  }
  
  // If it's a login request, reset timedOut to false so the login can proceed.
  if (config.url && config.url.includes('/session/login')) {
    timedOut = false;
  }
  
  preRequestProcessing();

  let data, response;
  try {
    callLevel++;
    response = await axios.request(config);
    callLevel--;
    if (response === undefined) {
      return Promise.reject(new Error('No response'));
    }
    data = normalizeResponseData(response.data);
  } catch (err) {
    callLevel--;
    const errData = normalizeResponseData(err.response?.data);
    if (isSessionTimeoutPayload(errData)) {
      return handleSessionTimeout();
    }
    return Promise.reject(err);
  }

  const csrf = data?.csrf;
  if (csrf && csrf.param != null && csrf.token != null) {
    store.dispatch('login/updateCsrf', csrf);
  }

  if (config.url && config.url.includes('/session/logout')) {
    postRequestProcessing({ config });
    return response;
  }

  if (response && data) {
    if (isSessionTimeoutPayload(data)) {
      return handleSessionTimeout();
    }
    if (data.message === START_LOGIN_MESSAGE || data.status === NOTLOGGEDIN) {
      store.dispatch('login/resetSession');
    } else {
      postRequestProcessing({ config });
    }

    if (data.status === ERROR) {
      throw data.message;
    }
  }
  return response;
}






function preRequestProcessing(reqParams) {
  // TODO: 
}

// function postRequestProcessing(info) {
//   let action = info.config.data.action;
//   let ping = action !== 'ping' && action !== 'saveState';
//   Vue.vueEventBus.$emit(RESET_TIMER,{ping});
// }

function postRequestProcessing(info) {
  let action = info.config?.data?.action;
  let ping = action !== 'ping' && action !== 'saveState';
  EventBus.emit('RESET_TIMER', { ping });
}
